/**
 * interface
 *
 * @author Shigq
 * @date 2020/12/9 21:31
 */

const { gateway } = require('../config')

const common = {
  dictCache: `${gateway.user}/client/v1/getDictCache`,
  getEnumCache: `${gateway.user}/client/v1/ref/getEnumCache`,
  listCountryCode: `${gateway.user}/client/v1/ref/listCountryCode`,
  listCnapsCode: `${gateway.user}/client/v1/ref/listCnapsCode`,
  listCurrency: `${gateway.user}/client/v1/ref/listCurrency`,
  uploadFile: `${gateway.user}/api/v1/file/ossUploadFile`, // /api/v1/file/ossUploadFile
  growUploadFile: `${gateway.user}/api/v1/growKyc/uploadFile`,
  growGetFileInfo: `${gateway.user}/api/v1/growKyc/getFileInfo`,
  getFilePath: `${gateway.user}/api/v1/file/ossPreviewFile`,
  listDictionaryMapping: `${gateway.user}/client/api/v1/dictionary/listDictionaryMapping`,
  clientCountryCode: `${gateway.user}/api/v1/countryCode/list`
}

const user = {
  register: `${gateway.user}/api/v1/user/register`,
  getRegisterInfo: `${gateway.user}/client/v1/acctMaster/getAcctInfo`,
  sendMobilePhoneCode: `${gateway.user}/api/v1/nt/sendMobileCode`,
  sendEmailCode: `${gateway.user}/api/v1/nt/sendEmailCode`,
  checkEmail: `${gateway.user}/api/v1/user/checkEmail`,
  login: `${gateway.user}/api/v1/user/login`,
  logout: `${gateway.user}/api/v1/user/loginOut`,
  // 获取用户信息
  getUserInfo: `${gateway.user}/api/v1/user/getUserInfo`,
  // 重置密码
  modifyPassword: `${gateway.user}/api/v1/user/modifyPassword`,
  resetPasswordByEmail: `${gateway.user}/api/v1/user/resetPasswordByEmail`,
  bindingEmail: `${gateway.user}/api/v1/user/bindingEmail`,
  resetPasswordByCellphone: `${gateway.user}/api/v1/user/resetPasswordByMobile`,
}

const register = {
  getAuthInfo: `${gateway.user}/client/v1/register/getRegisterInfo`,
  addRegisterInfo: `${gateway.user}/client/v1/register/addRegisterInfo`,
  addCompanyInfo: `${gateway.user}/client/v1/compInfo/addCompanyInfo`,
  addCompanyUser: `${gateway.user}/client/v1/compUser/addCompanyUser`,
  modifyRegisterInfo: `${gateway.user}/client/v1/register/modifyRegisterInfo`,
  modifyCompanyInfo: `${gateway.user}/client/v1/compInfo/modifyCompanyInfo`,
  modifyCompanyUser: `${gateway.user}/client/v1/compUser/modifyCompanyUser`,
  openRegisterFxPay: `${gateway.user}/client/v1/register/openRegisterFxPay`
}

const auth = {
  // -------------------------------------企业认证----------------------------------------- //
  // 公司注册信息
  addCompRegMaterial: `${gateway.user}/api/v1/comp/addCompRegMaterial`, // 提交
  getCompRegInfo: `${gateway.user}/api/v1/comp/getCompRegInfo`, // 获取
  updateCompRegInfo: `${gateway.user}/api/v1/comp/updateCompRegInfo`, // 更改

  // 企业信息
  addCompanyInfo: `${gateway.user}/api/v1/comp/addCompanyInfo`, // 提交企业信息材料
  getCompanyInfo: `${gateway.user}/api/v1/comp/getCompanyInfo`, // 获取企业信息材料
  updateCompanyInfo: `${gateway.user}/api/v1/comp/updateCompanyInfo`, // 获取企业信息材料

  // 公司股东信息
  getCompShareholderInfo: `${gateway.user}/api/v1/comp/getCompShareholderInfo`, // 获取
  addCompanyShareholderInfo: `${gateway.user}/api/v1/comp/addCompanyShareholderInfo`, // 新增
  updateCompShareholderInfo: `${gateway.user}/api/v1/comp/updateCompShareholderInfo`, // 更改

  // 企业总览信息
  getCompKycInfo: `${gateway.user}/api/v1/comp/getCompKycInfo`, // 获取

  // -------------------------------------个人认证----------------------------------------- //
  // 个人认证
  addPersonRegInfo: `${gateway.user}/api/v1/individual/addPersonRegInfo`, // 提交个人注册材料
  getPersonRegInfo: `${gateway.user}/api/v1/individual/getPersonRegInfo`, // 获取
  updatePersonRegInfo: `${gateway.user}/api/v1/individual/updatePersonRegInfo`, // 修改

  // 个人总览
  getIndividualMaterial: `${gateway.user}/api/v1/individual/getIndividualMaterial`, // 获取

  // -------------------------------------通用----------------------------------------- //
  // 总提交通用
  submitCompKycInfo: `${gateway.user}/api/v1/comp/submitCompKycInfo`, // 总提交
  getKycInfo: `${gateway.user}/api/v1/kyc/getKycInfo`, // 获取dashboard步骤

  // 业务信息
  getBusinessInfo: `${gateway.user}/api/v1/comp/getBusinessInfo`, // 获取
  updateBusinessInfo: `${gateway.user}/api/v1/comp/updateBusinessInfo`, // 更改
  addBusinessInfo: `${gateway.user}/api/v1/comp/addBusinessInfo`, // 提交

  // 协议文件
  addAgreementFile: `${gateway.user}/api/v1/agg/addAgreementFile`, // 上传
  getAgreementInfo: `${gateway.user}/api/v1/agg/getAgreementInfo`, // 获取

  // 银行卡文件
  addBankAcct: `${gateway.user}/api/v1/bankAcct/add`, // 添加
  getBankAcct: `${gateway.user}/api/v1/bankAcct/list`, // 获取
  updateBankAcct: `${gateway.user}/api/v1/bankAcct/update`, // 更新

  // 推荐信息列表查询
  getReferrerList: `${gateway.user}/api/v1/referrer/list`, // 查询
  // 修改备注
  updateRemark: `${gateway.user}/api/v1/referrer/updateRemark`, // 修改备注
  // dashboard概览
  homeOverview: `${gateway.user}/api/v1/dashboard/homeOverview`, // 首页累计指标
  openAcctConversionTrend: `${gateway.user}/api/v1/dashboard/openAcctConversionTrend`, // 开户转化率折线
  payTrend: `${gateway.user}/api/v1/dashboard/payTrend`, // 支付交易趋势折线
  transinTrend: `${gateway.user}/api/v1/dashboard/transinTrend`, // 收款交易趋势折线
}

const list = {
  fetchCollection: `${gateway.user}/api/v1/collection/list`, // 关联收款列表查询
  fetchCustomer: `${gateway.user}/api/v1/customer/list`, // 关联客户列表
  fetchRegisteringList: `${gateway.user}/api/v1/register/listRegistering`, // 未开户列表
  listByAcctName: `${gateway.user}/api/v1/customer/listByAcctName`, // 关联客户列表模糊查询
  fetchPayment: `${gateway.user}/api/v1/payment/list`, // 关联交易列表
  getAcctBusiness: `${gateway.user}/api/v1/growKyc/getAcctBusiness`, // 获取growkyc信息
  saveAcctBusiness: `${gateway.user}/api/v1/growKyc/saveAcctBusiness`, // 保存growkyc信息
  accountList: `${gateway.user}/api/v1/virtualAccount/list`, // 收款账户列表
  export: `${gateway.user}/api/v1/customer/export`, // 关联客户列表
  collectionExport: `${gateway.user}/api/v1/collection/export`, // 收款列表导出
  paymentExport: `${gateway.user}/api/v1/payment/export`, // 交易列表导出
  salesSettlementList: `${gateway.user}/api/v1/saleSettlement/list`, // 销售结算列表
  salesSettlementExport: `${gateway.user}/api/v1/saleSettlement/export`, // 销售结算导出
}
const settlement = {
  initLiveness: `${gateway.user}/api/v1/face/initLiveness`,
  listSettlement: `${gateway.user}/api/v1/settlement/listSettlement`, // 获取结算列表
  billConfirm: `${gateway.user}/api/v1/settlement/billConfirm`, // 确认账单详情
  updateBankInfo: `${gateway.user}/api/v1/settlement/updateBankInfo`, // 更新银行信息
  uploadInvoice: `${gateway.user}/api/v1/settlement/uploadInvoice`, // 上传发票
  getCurrentSettlementInfo: `${gateway.user}/api/v1/settlement/getCurrentSettlementInfo`, // 获取当前结算信息
  listInvoiceInfo: `${gateway.user}/api/v1/settlement/listInvoiceInfo`, // 获取发票信息列表
  modifyInvoiceInfo: `${gateway.user}/api/v1/settlement/modifyInvoiceInfo`, // 修改发票信息
  faceVerification: `${gateway.user}/api/v1/face/faceVerification`, // 人脸验证
}
module.exports = {
  user,
  common,
  register,
  auth,
  list,
  settlement
}
